import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import utils from '../../utils'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { IoTrashBinSharp } from "react-icons/io5";
import toast from 'react-hot-toast';

function CartItem(props) {
    const item = props.item
    const [quantity, setQuantity] = useState()

    useEffect(() => {
        setQuantity(item?.quantity)
    }, [item])
    useEffect(() => { }, [quantity])

    function addItemQuantity() {
        if (quantity >= item?.product?.quantity) {
            toast.error(`Only ${item?.product?.quantity} remaining.`)
            return
        }
        props.updateItemQuantity(item, quantity + 1)
        setQuantity(quantity + 1)
    }
    function reduceItemQuantity() {
        props.updateItemQuantity(item, quantity - 1)
        setQuantity(quantity - 1)
    }
    return (
        <div className='mb-4'>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 rounded-md hover:shadow-lg border p-3 shadow-md gap-4  md:gap-3">
                <div className="place-self-center flex gap-6 items-center">
                    <div>{props.idx + 1} .</div>
                    <Link className='' to={'/product/' + item?.product?.slug}>
                        <div className="avatar">
                            <div className="rounded-lg mask w-14 h-14 lg:w-16 lg:h-16 ">
                                <img src={utils.baseUrl + item?.product?.image} alt={item?.product?.name} />
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="place-self-center text-sm font-bold md:text-base">
                    <Link className='' to={'/product/' + item?.product?.slug}>
                        {item?.product?.name}
                    </Link>
                </div>
                <div className="place-self-center">
                    <div className="flex items-center">
                        <button
                            onClick={() => reduceItemQuantity()}
                            className='btn btn-error btn-sm btn-circle hover:cursor-pointer'><AiOutlineMinus /></button>
                        <span className='ml-3 mr-3 text-lg'>
                            <p>{quantity}</p>
                        </span>
                        <button
                            onClick={() => addItemQuantity()}
                            className='btn btn-success btn-sm btn-circle hover:cursor-pointer'><AiOutlinePlus /></button>
                    </div>
                </div>
                <div className="font-bold place-self-center text-sm md:text-base">
                    KSHS: {utils.toCommas(item?.total)}
                </div>
                <div className="place-self-center flex items-center gap-3">
                    <div>
                        <button
                            onClick={() => props.deleteItem(item)}
                            className='btn btn-error btn-sm'
                        ><IoTrashBinSharp className='mr-2' /> Remove</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartItem